var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9725 0C4.17121 0.000169048 4.36227 0.0791971 4.50278 0.219727L7.72543 3.44238C8.0181 3.73519 8.01698 4.21006 7.72446 4.50293C7.43154 4.79579 6.95677 4.79585 6.66391 4.50293L4.7225 2.56055V12.0303C4.7225 12.4443 4.38642 12.7799 3.9725 12.7803C3.55829 12.7803 3.2225 12.4445 3.2225 12.0303V2.56055L1.28012 4.50293C0.987256 4.79585 0.512495 4.79579 0.219574 4.50293C-0.0731265 4.21005 -0.0732174 3.73523 0.219574 3.44238L3.44223 0.219727L3.55649 0.125977C3.67866 0.0447042 3.8236 0 3.9725 0ZM12.0282 0C12.4421 0.000212395 12.778 0.336082 12.7782 0.75V10.2197L14.7206 8.27734C15.0135 7.98492 15.4883 7.98465 15.7811 8.27734C16.0736 8.5701 16.0735 9.04504 15.7811 9.33789L12.5584 12.5605C12.4179 12.7011 12.227 12.7802 12.0282 12.7803C11.8292 12.7803 11.6386 12.7012 11.4979 12.5605L8.27524 9.33789C7.98246 9.04505 7.98257 8.57023 8.27524 8.27734C8.56815 7.98487 9.04303 7.98464 9.33578 8.27734L11.2782 10.2197V0.75C11.2784 0.335951 11.6141 0 12.0282 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDown);
export default __webpack_public_path__ + "static/media/up-down.ca99b187dd76c49f4f82d8c371fbde89.svg";
export { ForwardRef as ReactComponent };